
    import StepContainer from './common/StepContainer.vue'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'
    import Vue from 'vue'
    import RatingScaleSelector from './common/RatingScaleSelector.vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'
    import HelperMethods from './common/HelperMethods'
    import TipsSelector from './common/TipsSelector.vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import Checkbox from './common/Checkbox.vue'
    import SelectTypeSelector from './common/SelectTypeSelector.vue'
    import AnswerOptionsSelector from './common/AnswerOptionsSelector.vue'

    export default Vue.extend({
        //--------
        data () {
            return {
            }
        },
        //--------
        mixins: [RepeatingStepLogic, HelperMethods],
        //--------
        created (): void {   
            
        },
        //---------
        props: {
            compIndex: Number
        },
        //--------
        components: {
            surveystep: StepContainer,
            ContentDisplayClosed,
            TipsSelector,
            RatingScaleSelector,
            TextAreaButton,
            TextInputButton,
            Checkbox,
            SelectTypeSelector,
            AnswerOptionsSelector
        },
        computed: {
            choicesEditable(): boolean {

                //if this question has answers, the 'text' field of answerOptions are not editable (data integrity)
                //you can add or remove aOs, but not much else
                const qID = this.$store.getters["survey/stepField"]([this.compIndex, 'questionID'])
                let isEditable = true
                for (const q of this.$store.state.dash.viewData.questionsWithResponses) {
                    if (qID === q.questionID) {
                        isEditable = false
                        break
                    }
                }
                return isEditable

            },
            questionDetails(): any {
                const isMulti = this.$store.getters["survey/stepField"]([this.compIndex, 'type']) === 'multiq'
                return {
                    questionTypeName: isMulti ? 'Multi choice' : 'Single choice',
                    questionDescription: isMulti ? 'Respondents choose multiple options from a list.' : 'Respondents choose only one option from a list.'
                }
            }
        },
        //--------
        methods: {
        }
    })
